// frontend/services/customers.js
import api from './api';

export const customerService = {
    getCustomers: (params) => api.get('/customers', { params }).then(res => res.data),
    
    getCustomer: (id) => api.get(`/customers/${id}`).then(res => res.data),
    
    createCustomer: (data) => api.post('/customers', data).then(res => res.data),
    
    updateCustomer: (id, data) => api.put(`/customers/${id}`, data).then(res => res.data),
    
    deleteCustomer: (id) => api.delete(`/customers/${id}`).then(res => res.data),
    
    sendSMS: (id, message) => api.post(`/customers/${id}/sms`, { message }).then(res => res.data),
    
    getTransactions: (id, params) => api.get(`/customers/${id}/transactions`, { params }).then(res => res.data),
    
    getStatement: (id, params) => api.get(`/customers/${id}/statement`, { params, responseType: 'blob' }).then(res => res.data),
    
    getSummary: () => api.get('/customers/summary').then(res => res.data)
};